import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Box, CircularProgress, Typography, useTheme } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';

import { Content, Page } from '@spotify/confidence-core-react';
import { getError, getTypeOrNull } from '@spotify/confidence-graphql';

import { useStoreSlackUserInfoMutation } from '../../graphql';

export const SlackPage = () => {
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();

  const [save, { loading, data }] = useStoreSlackUserInfoMutation();
  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) return;
    save({
      variables: {
        code,
      },
      refetchQueries: ['GetCurrentUser'],
      onCompleted: response => {
        if (getTypeOrNull(response.storeSlackUserInfo)) {
          setSearchParams(
            params => {
              const newParams = new URLSearchParams(params);
              newParams.delete('code');
              newParams.append('success', 'true');
              return newParams;
            },
            { replace: true },
          );
        }
      },
    });
  }, [searchParams.get('code')]);
  const error = getError(data?.storeSlackUserInfo);
  const pending = (loading || searchParams.get('code')) && !error;
  return (
    <Page>
      <Content narrow>
        {error && <Alert severity="error">{error.message}</Alert>}
        {pending && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            gridGap={theme.spacing(4)}
            minHeight={200}
          >
            <CircularProgress />
            <Typography variant="body2">Connecting Slack</Typography>
          </Box>
        )}
        {!pending && searchParams.get('success') && (
          <Alert severity="success">
            <AlertTitle>Slack has been connected!</AlertTitle>
          </Alert>
        )}
      </Content>
    </Page>
  );
};
